import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { ROUTES } from "@/constants/routes";

export const Footer = () => {
  return (
    <footer className="mt-20 border-zinc-200 border-t bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 py-6 sm:flex-row sm:justify-between sm:px-6 sm:py-8">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary">
            <Sparkles className="h-4 w-4 text-white" />
          </div>
          <span className="font-bold text-zinc-900">Dualio</span>
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
          <Link
            to={ROUTES.PRIVACY}
            className="text-sm text-zinc-500 no-underline hover:text-zinc-900"
          >
            Privacy Policy
          </Link>
          <Link
            to={ROUTES.TERMS}
            className="text-sm text-zinc-500 no-underline hover:text-zinc-900"
          >
            Terms of Service
          </Link>
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
          <p className="text-sm text-zinc-400">
            © {new Date().getFullYear()} Dualio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
